import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import {
  CACHE_KEYS,
  CreateOrUpdateInvestmentParams,
  Investment,
  useEditInvestment,
} from "@rentablo/api/apiv1";
import { InvestmentEditAdvancedTabContainer } from "./InvestmentEditAdvancedTabContainer";

interface Props {
  investment: Investment;
}

export const InvestmentEditAdvancedTab = ({ investment }: Props) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const { mutateAsync: update, isPending, error } = useEditInvestment();

  const handleSaveClick = (data: CreateOrUpdateInvestmentParams) => {
    update(
      {
        id: investment.id,
        createOrUpdateInvestmentParams: data,
      },
      {
        onSuccess: async () => {
          enqueueSnackbar(
            `${t("investmentEditPage.basicTab.saved")}: ${investment.name}`,
            { autoHideDuration: 3000, variant: "success" }
          );
          await queryClient.invalidateQueries({
            queryKey: [CACHE_KEYS.INVESTMENTS_ID],
          });
        },
      }
    );
  };

  return (
    <InvestmentEditAdvancedTabContainer
      investment={investment}
      isSaving={isPending}
      error={error}
      onSave={handleSaveClick}
    />
  );
};
